import AppContext from "PFApp/app_context";
import useInsightsApi from "PFCore/helpers/use_insights_api";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import PlatformUsagePreview from "../previews/platform_usage_preview";
import PlatformUsageSigninsOverTime from "./charts/platform_usage_signins_over_time";
import PlatformUsageTiles from "./charts/platform_usage_tiles";

const PlatformUsagePage = () => {
  const {
    store: {
      pages: {
        insights: { selectedFilters }
      }
    }
  } = useContext(AppContext);
  const [graphData, setGraphData] = useState({});
  const [loading, setLoading] = useState({});
  const { insightsApi, insightsApiError } = useInsightsApi();
  const { t } = useTranslation("insights");

  useEffect(() => {
    setLoading(true);
    insightsApi("/platform_usage", selectedFilters).then((res) => {
      setGraphData(res);
      setLoading(false);
    });
  }, [selectedFilters]);

  if (loading) {
    return <PlatformUsagePreview content={t("loading")} animated />;
  }

  if (insightsApiError) {
    return <PlatformUsagePreview content={t("noData")} />;
  }

  return (
    <>
      <PlatformUsageTiles data={graphData.interest_data} loading={loading} />
      <PlatformUsageSigninsOverTime data={graphData.sign_ins_graph} loading={loading} />
    </>
  );
};

export default PlatformUsagePage;
